import { render, staticRenderFns } from "./Auditoria.vue?vue&type=template&id=6a46d790&"
import script from "./Auditoria.vue?vue&type=script&lang=ts&"
export * from "./Auditoria.vue?vue&type=script&lang=ts&"
import style0 from "./Auditoria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6a46d790', component.options)
    } else {
      api.reload('6a46d790', component.options)
    }
    module.hot.accept("./Auditoria.vue?vue&type=template&id=6a46d790&", function () {
      api.rerender('6a46d790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administracion/Auditoria.vue"
export default component.exports